var _ellipse, _path, _rect, _path2, _rect2, _path3, _rect3, _ellipse2, _path4, _circle, _circle2, _circle3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 90,
    viewBox: "0 0 114 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.1844,
    cy: 51.5044,
    rx: 38.2206,
    ry: 38.4956,
    fill: "#D5D5D5",
    fillOpacity: 0.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.655 51.5044C106.655 72.3557 89.8738 89.2499 69.1845 89.2499C48.4951 89.2499 31.7139 72.3557 31.7139 51.5044C31.7139 30.653 48.4951 13.7588 69.1845 13.7588C89.8738 13.7588 106.655 30.653 106.655 51.5044Z",
    stroke: "#AAAAAA",
    strokeOpacity: 0.26,
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1133,
    y: 25.0576,
    width: 86.1429,
    height: 52.8938,
    rx: 7.5,
    fill: "white",
    stroke: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3625 43.4205C64.3625 47.2179 60.8258 50.5046 56.1895 50.5046C51.5533 50.5046 48.0166 47.2179 48.0166 43.4205C48.0166 39.6231 51.5533 36.3364 56.1895 36.3364C60.8258 36.3364 64.3625 39.6231 64.3625 43.4205Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.0166,
    y: 35.3364,
    width: 18.3459,
    height: 10.0089,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1164 43.4205C91.1164 47.2179 87.5797 50.5046 82.9435 50.5046C78.3072 50.5046 74.7705 47.2179 74.7705 43.4205C74.7705 39.6231 78.3072 36.3364 82.9435 36.3364C87.5797 36.3364 91.1164 39.6231 91.1164 43.4205Z",
    fill: "white",
    stroke: "#AAAAAA",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7705,
    y: 35.3364,
    width: 18.3459,
    height: 10.0089,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.0689,
    cy: 63.0534,
    rx: 4.58647,
    ry: 2.30974,
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.755 28.4521V28.2518C112.755 26.008 110.81 24.25 108.488 24.25H30.1417C27.8202 24.25 25.875 26.008 25.875 28.2518V28.4521V28.9521V30.3529V33.8547V34.3547H26.375H30.1417H108.488H112.255H112.755V33.8547V30.3529V28.9521V28.4521Z",
    fill: "#EEEEEE",
    stroke: "#AAAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1133,
    cy: 32.0576,
    r: 1.5,
    fill: "#AAAAAA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1133,
    cy: 32.0576,
    r: 1.5,
    fill: "#AAAAAA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1133,
    cy: 32.0576,
    r: 1.5,
    fill: "#AAAAAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1008 11.2562H32.3994V13.3449H22.8828V11.8195L29.0613 2.8317H22.8914V0.725586H32.2621V2.21633L26.1008 11.2562Z",
    fill: "#797979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3914 19.9139H40.1153V21.4805H32.9779V20.3364L37.6117 13.5956H32.9843V12.016H40.0123V13.134L35.3914 19.9139Z",
    fill: "#797979"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.6a74c98fb740653be37f952ff4a802ab.svg";
export { ForwardRef as ReactComponent };